const KEY_PREFIX = "myrent:recentLocations";
const MAX_RECENT = 5;

function safeCompanyCode(): string {
  const raw = process.env.REACT_APP_COMPANY_CODE || "_";
  return raw.replace(/[^a-zA-Z0-9_-]/g, "_");
}

function safeField(field: string): string {
  return String(field || "_").replace(/[^a-zA-Z0-9_-]/g, "_");
}

function storageKey(field: string): string {
  return `${KEY_PREFIX}:${safeCompanyCode()}:${safeField(field)}`;
}

/** Read the recent list. Returns an empty array on any parse / access error. */
export function readRecentLocations(field: string): string[] {
  try {
    if (typeof window === "undefined" || !window.localStorage) return [];
    const raw = window.localStorage.getItem(storageKey(field));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((v): v is string => typeof v === "string")
      .slice(0, MAX_RECENT);
  } catch {
    return [];
  }
}

export function pushRecentLocation(field: string, locationCode: string): void {
  if (!locationCode) return;
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    const current = readRecentLocations(field);
    const next = [
      locationCode,
      ...current.filter((c) => c !== locationCode),
    ].slice(0, MAX_RECENT);
    window.localStorage.setItem(storageKey(field), JSON.stringify(next));
  } catch {
    // Ignore quota / disabled-storage errors.
  }
}

export function clearRecentLocations(field: string): void {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.removeItem(storageKey(field));
  } catch {
    // Ignore.
  }
}
